import { useEffect } from 'react';

/**
 * Used to put all the hovered element on the view, currently getting the right side of it
 *      because the popover is displayed on the right
 * When it was centered and the mouse was at the right edge it kept scrolling to the next element
 *      until it reached the end of the list
 * The smooth scroll takes around 150ms make sure any related action happens later
 * @param {object} ref react useref for the list
 * @param {boolean} bringIntoView should this be functional at all
 * @param {number} distanceToRightEdge how close do we want to move the element to the right edge 0 is attached
 */
const useBringToView = ({ ref, bringIntoView, distanceToRightEdge }) => {
    useEffect(() => {
        const mouseEnter = (e) => {
            if (!e.target || !e.target.closest('li')) {
                return;
            }
            const li = e.target.closest('li');
            const ul = li.closest('ul');
            const relativeRight = li.offsetLeft + li.clientWidth;

            if (ul.clientWidth < relativeRight - ul.scrollLeft) {
                const distanceFromLeft = relativeRight - ul.clientWidth + distanceToRightEdge;
                ul.scrollTo({ left: distanceFromLeft, behavior: 'smooth' });
            }
        };
        const addChildrenEvents = () => {
            if (!ref.current || ref.current.assigned) {
                return;
            }
            ref.current.childNodes.forEach((child) => {
                child.addEventListener('mouseenter', mouseEnter);
            });
            ref.current.assigned = true;
        };
        const removeChildrenEvents = () => {
            if (!ref.current) {
                return;
            }
            ref.current.childNodes.forEach((child) => {
                child.removeEventListener('mouseenter', mouseEnter);
            });
        };

        if (bringIntoView) {
            addChildrenEvents();
        }

        return () => {
            removeChildrenEvents();
        };
    }, [ref, bringIntoView, distanceToRightEdge]);
};

export default useBringToView;
